import { render, staticRenderFns } from "./InfoAboutCustomer.vue?vue&type=template&id=015df13f&"
import script from "./InfoAboutCustomer.vue?vue&type=script&lang=js&"
export * from "./InfoAboutCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports